import React, {useState, useEffect} from "react";
import { useSelector, useDispatch} from 'react-redux';
import { useParams, useHistory, Link } from 'react-router-dom';
import {Helmet} from "react-helmet-async";
import { Loader, Modal, Button } from 'rsuite';
import {CardActions , Button as BtnMui} from '@material-ui/core';
import parse from 'html-react-parser';
import * as actionsAdmin  from '../../../../app/actions/admin';
import { deleteNews } from '../../../../app/common/services/fetch.admin.service';
import ShareBox from './ShareBox';
import NewsCard from "./NewsCard";
import NewsMain from './NewsMain';

const cutString = (str, i = 70) => {
    if (!str || str.length < i) return str;
  
    str = str.substring(0, i);
  
    const lastIndex = str.lastIndexOf(" ");
  
    str = str.substring(0, lastIndex);
  
    return str = str + "..."
  
  }

const NewsDetails = () => {

    const dispatch = useDispatch();

    const { id } = useParams();

    const history = useHistory();

    const userDetails = useSelector(state => state.userDetails);
    const roleName = userDetails?.roleName;
    const isAdmin = roleName?.includes('ADMIN');

    const {newsData} = useSelector(state => state.news);

    const [news, setNews] = useState({});
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState({show: false, msg: ''});

    const ogUrl = `https://nuins.io/news-details/${id}`;
    const ogTitle = news?.title ? news?.title : "Евтина гражданска отговорност от NuINS";
    const ogImage = news?.image ? news?.image : "https://nuins.io/img/cta-bg.png";
    const ogDesc = news?.textData ? cutString(news?.textData) : "Гражданска отговорност бързо и лесно, онлайн с NuINS";

    const newsText = news?.textData ? parse(cutString(news?.textData, 120)) : "";
    const newsTextFull = news?.textData ? parse(news?.textData) : "";

    useEffect(()=>{
        const fetchNews = async () => {
            setLoading(true);
            await dispatch(actionsAdmin.getNews());
            setLoading(false);
        }

        if(!newsData?.length) {
            fetchNews();
        }
    }, []);

    useEffect(()=>{
        const getNews = async () => {
            const news = newsData.find(obj => obj.id === id )
            setNews(news);
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
        }

        if(newsData?.length) {
            getNews();
        }
    }, [newsData, id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const onDeleteNews = async () => {
        setLoading(true);

        let res;

        try{
            res = await deleteNews(news.id);
        } catch (error) {
          console.log(error);
        }

        if(res?.data && !res.data.status) {
            setShowModal({show: true, msg: `Новината е изтрита успешно`, success: true});
            
        } else {
            setShowModal({show: true, msg: `Грешка, моля опитайте отново`});
        }

        setLoading(false);
    }

    const onDeleteSuccess = async () => {
        setLoading(true);
        await dispatch(actionsAdmin.getNews());
        return history.goBack();
    }

    const onDeleteError = () => {
        setShowModal({show:false, msg:''});
    }

    return (
        <section className="news-details">
            <Helmet>
                <title>{ogTitle} </title>
                <meta property="og:site_name" content={ogTitle}/>
                <meta property="og:url" content={ogUrl} />
                <meta property="og:title" content={ogTitle} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:description" content={ogDesc} /> 
                <meta property="og:image:width" content="560" />
                <meta property="og:image:height" content="400" />
            </Helmet>
            <div className="container-main">
                {false ? <div className="card">
                    <NewsCard news={news} isDetails={true} onDelete = {onDeleteNews}/>
                </div> : null}
                <div className="card-new MuiPaper-elevation1">
                    <div className="top">
                        <div className="first">
                            <div className="text-box">
                            {false ? <h5>Новини</h5> : null}
                                <h1>{news?.title}</h1>
                                <p>{newsText} </p>
                            </div>
                        </div>
                        <div className="second">
                            <div className="left">
                                <h5>Споделете:</h5>
                                <ShareBox newsId={news?.id} />
                            </div>
                            <div className="right"></div>
                        </div>
                        <div className="image">
                            <img src={news?.image} />
                        </div>
                    </div>
                    <div className="bottom">
                        <div className="left">
                            {newsTextFull}
                            
                            {isAdmin 
                            ? <div style={{marginTop: '20px'}}>
                                <BtnMui size="small" color="primary" onClick={onDeleteNews}>
                                    Delete news
                                </BtnMui></div> 
                            : null}
                        </div>
                        <div className="banner">
                            <h4 className="first">Гражданска отговорност <br></br> On-line</h4>
                            {false 
                            ? <h4 className="second">Изберете сами <br></br>най-добрaтa <br></br> цена<br></br>и застраховател</h4>
                            : <h4 className="second"> бързо и лесно <br></br> с </h4>
                            }

                            <figure className="logo-box">
                                <img src="/img/logo-dark.png" alt="Застраховай се в движение с NuIns"></img>
                            </figure>
                            <Link to="/app/new-policy-liability" className="nuIns-btn nuIns-btn-landing link-btn">Купете сега <span className="points">...</span></Link>
                        </div>

                    </div>
                </div>
                <div className="container-news">
                    <NewsMain />
                </div>
            </div>
            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
            <Modal size="xs" className="nuins-ok-modal" show={showModal?.show} onHide={()=> showModal?.success ? onDeleteSuccess() : onDeleteError()}>
                <Modal.Body>
                    <p className="">{showModal?.msg}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={()=> showModal?.success ? onDeleteSuccess() : onDeleteError()} >OK</Button>
                </Modal.Footer>
                {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}
            </Modal>
        </section>
    )
}

export default NewsDetails;